import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/components/Modal.module.css";
import Loading from "./Loading";

const Modal = ({
  message,
  type, // "ok" para modal simple, "confirm" para confirmar
  onClose,
  onConfirm,
  linkText,
  linkTo,
}) => {

  if(type === "loader"){
    return <div className={styles.modalOverlay}>
            <Loading></Loading>
           </div>
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <p>{message}</p>

        {linkTo && (
          <Link to={linkTo} className={styles.modalLink}>
            {linkText}
          </Link>
        )}

        <div className={styles.modalButtons}>
          {type === "ok" ? (
            <button onClick={onClose} className={styles.okButton}>
              Ok
            </button>
          ) : (
            <>
              <button onClick={onClose} className={styles.cancelButton}>
                No
              </button>
              <button onClick={onConfirm} className={styles.confirmButton}>
                Yes
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
